// Display metadata for site-visit statuses and outcomes. Kept in one place so
// the calendar, list, detail and badges all read the same labels/colours.

export const STATUS_META = {
  scheduled:   { label: "Scheduled",   className: "bg-blue-100 text-blue-700" },
  confirmed:   { label: "Confirmed",   className: "bg-indigo-100 text-indigo-700" },
  checked_in:  { label: "Checked in",  className: "bg-emerald-100 text-emerald-700" },
  completed:   { label: "Completed",   className: "bg-slate-200 text-slate-700" },
  cancelled:   { label: "Cancelled",   className: "bg-rose-100 text-rose-700" },
  no_show:     { label: "No show",     className: "bg-amber-100 text-amber-700" },
  rescheduled: { label: "Rescheduled", className: "bg-purple-100 text-purple-700" },
};

export const OUTCOME_META = {
  interested:     { label: "Interested",      className: "bg-emerald-100 text-emerald-700" },
  not_interested: { label: "Not interested",  className: "bg-rose-100 text-rose-700" },
  needs_followup: { label: "Needs follow-up",  className: "bg-amber-100 text-amber-700" },
  booked:         { label: "Booked",           className: "bg-blue-100 text-blue-700" },
  revisit:        { label: "Revisit",          className: "bg-purple-100 text-purple-700" },
};

export const OUTCOMES = Object.keys(OUTCOME_META);

export const CHECKIN_META = {
  verified:        { label: "Verified",        className: "bg-emerald-100 text-emerald-700" },
  out_of_range:    { label: "Out of range",     className: "bg-rose-100 text-rose-700" },
  manual_override: { label: "Manual override",  className: "bg-amber-100 text-amber-700" },
};

export function formatDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString([], {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}
